import React, { useContext, useEffect, useReducer, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import Collapse from 'react-bootstrap/Collapse';
import { Link, NavLink, useLocation } from "react-router-dom";
import { Badge, Tooltip, OverlayTrigger } from "react-bootstrap";
import { useMenuList } from './Menu';
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";

import routeMap from './SidebarRouteMap'; // Import your new route map

const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active: "",
  activeSubmenu: "",
}

const SideBar = (permissions) => {

  const MenuList = useMenuList();
  // --------------------------------------------------- permissions ----------------------------------------------------
  const [mypermissions, setPermissions] = useState(permissions.permissions);
  // --------------------------------------------------- end ----------------------------------------------------


  const {
    iconHover,
    sidebarposition,
    headerposition,
    sidebarLayout,
  } = useContext(ThemeContext);

  const [state, setState] = useReducer(reducer, initialState);

  const location = useLocation();
  // Remove leading slash for consistency with routeMap keys
  // Normalize the path
  let currentPath = location.pathname;
  if (currentPath.startsWith('/')) {
    currentPath = currentPath.slice(1);
  }
  currentPath = currentPath.split('?')[0].split('#')[0]; // Clean up query/hash

  const matchedKey = Object.keys(routeMap).find(key => currentPath.startsWith(key));


  const [hideOnScroll, setHideOnScroll] = useState(true);
  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y;
      if (isShow !== hideOnScroll) setHideOnScroll(isShow);
    },
    [hideOnScroll]
  );

  // Get current menu and submenu from map
  const routeMatch = routeMap[matchedKey] || {};
  const activeMenu = routeMatch.menu;
  const activeSubmenu = routeMatch.submenu;

  const handleMenuActive = status => {
    setState({ active: state.active === status ? "" : status });
  };

  const handleSubmenuActive = status => {
    setState({ activeSubmenu: state.activeSubmenu === status ? "" : status });
  };


  return (
    <div className="dlabnav border-right pt-3">
      <PerfectScrollbar className="dlabnav-scroll">
        <ul className="metismenu" id="menu">
          {MenuList.map((data, index) => {

            // --------------------------------------------------- sub menu permissions ----------------------------------------------------

            if (data.permission && mypermissions[data.permission] !== 1) return null;

            // --------------------------------------------------- end ---------------------------------------------------------------------

            const isActiveMenu = data.title === activeMenu;
            let menuClass = data.classsChange;

            if (menuClass === "menu-title") {
              return (
                <li className={menuClass} key={index}>{data.title}</li>
              );
            } else {
              return (
                <li key={index} className={`${data.content && data.content.length > 0 && isActiveMenu ? 'mm-active' : ''}`}>
                  {data.content && data.content.length > 0 ? (
                    <>
                      <Link to="#" className="d-flex align-items-center has-arrow mb-1 mt-0 gap-0 py-2" onClick={() => handleMenuActive(data.title)}>
                        <div className="me-2"><i className={`mb-1 ${data.iconStyle}`}></i></div>
                        <div className="flex-wrap"><span className="nav-text">{data.title}</span></div>
                      </Link>
                      <Collapse in={state.active === data.title || isActiveMenu}>
                        <ul className={`${menuClass === "mm-collapse" ? "mm-show" : ""} bg-primary`}>
                          {data.content.map((subItem, subIndex) => {
                            const isSubmenuActive = subItem.title === activeSubmenu;

                            // --------------------------------------------------- sub menu permissions ----------------------------------------------------

                            if (subItem.permission && mypermissions[subItem.permission] !== 1) return null;

                            // ------------------------------------------------------ end ------------------------------------------------------------------

                            return (
                              <li key={subIndex} className={`${isSubmenuActive ? 'mm-active active-menu' : ''}`}>
                                <Link to={subItem.to}>
                                  {subItem.title}
                                  {subItem.count > 0 && (
                                    <>
                                      <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>{subItem.tooltip}</span></Tooltip>} >
                                        <Badge bg="light" className='text-primary ms-2 fw-bold fs-8 rounded-pill text-center '>
                                          {subItem.count}
                                        </Badge>
                                      </OverlayTrigger>
                                    </>
                                  )}
                                </Link>
                              </li>
                            );
                          })}
                        </ul>
                      </Collapse>
                    </>
                  ) : (
                    <Link
                      to={data.to}
                      className={`d-flex align-items-center mb-1 mt-0 py-2 gap-0 ${data.title == activeMenu ? 'active-menu' : ''}`}
                    >
                      <div className="me-2">
                        <i className={`mb-1 ${data.iconStyle}`}></i>
                      </div>
                      <div className="flex-wrap">
                        <span className="nav-text">{data.title}</span>
                      </div>
                    </Link>
                  )}
                </li>
              );
            }
          })}
        </ul>
      </PerfectScrollbar>
    </div>
  );
};

export default SideBar;
